import { BookingState, ActionType, ReduxAction } from 'types';

const initialState: BookingState = {
  appointmentTypeId: null,
  calendar: {
    activeAppointmentTypeId: null,
    activePhysicianId: null,
    activeServiceLocationId: null,
    currentMonth: '',
    isLoadingAvailabilities: false,
  },
  locationPhysiciansWithHypotheticalAvailability: null,
  patient: {
    dob: '',
    email: '',
    firstName: '',
    id: undefined,
    lastName: '',
    actualName: '',
    phone: '',
    sex: undefined,
  },
  physicianId: null,
  scheduledDate: '',
  selectedAppointmentTypeIds: null,
  selectedPhysicianId: null,
  selectedServiceLocationId: null,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
};

export const bookingReducer = (
  state: BookingState = initialState,
  action: ReduxAction,
): BookingState => {
  switch (action.type) {
    case ActionType.SetPatientInfo:
      return {
        ...state,
        patient: action.payload.patient,
      };

    case ActionType.UpdateBookingPatientInfo:
      return {
        ...state,
        patient: {
          ...state.patient,
          ...action.payload.patient,
        },
      };

    case ActionType.UpdateBookingInfo: {
      return {
        ...state,
        ...action.payload,
        patient: { ...state.patient, ...action.payload.patient },
        calendar: { ...state.calendar, ...action.payload.calendar },
      };
    }

    case ActionType.ClearBookingInfo:
      // We don't want to discard the timezone selected by the patient
      return { ...initialState, timezone: state.timezone };

    default:
      return state;
  }
};
